import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"
import { debounce } from "lodash";
import axios from "axios";

export default class extends Controller {
  static get targets() {
    return ["packagingWeightInput", "grossWeightInput"]
  }

  initialize() {
    this.updateQuantity = debounce(this.updateQuantity, 800).bind(this)
    this.updateWeight = debounce(this.updateWeight, 800).bind(this)
  }

  updateQuantity(event) {
    this.performUpdate({ quantity: event.target.value }, event.target);
  }

  updateWeight(event) {
    this.performUpdate({ weight: this.normalizeWeight(event.target.value) }, event.target);
  }

  performUpdate(data, targetElement) {
    const url = `/office/legacy/destinations/${this.destinationId}.json`;
    const requestData = { legacy_destination: data };
    const preloader = targetElement.closest(".control");
    
    preloader.classList.add("is-loading");

    const controller = this; 
    
    axios.patch(url, requestData, {
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': Rails.csrfToken()
      }
    })
    .then((response) => {
      const responseData = response.data;
      
      const currentRow = controller.element;

      const packagingInput = currentRow.querySelector('[data-legacy-destination-target="packagingWeightInput"]');
      const grossInput = currentRow.querySelector('[data-legacy-destination-target="grossWeightInput"]');

      // 3. Обновляем их значения
      if (packagingInput) {
        packagingInput.value = responseData.destination.packaging_weight.toFixed(2);
      }
      if (grossInput) {
        grossInput.value = responseData.destination.gross_weight.toFixed(2);
      }
      
      document.getElementById('waybill-total-quantity').textContent = responseData.waybill_totals.quantity;
      document.getElementById('waybill-total-weight').textContent = responseData.waybill_totals.weight;
      document.getElementById('waybill-total-packaging-weight').textContent = responseData.waybill_totals.packaging_weight;
      document.getElementById('waybill-total-gross-weight').textContent = responseData.waybill_totals.gross_weight;
    })
    .catch(function (error) {
      console.log(error);
    })
    .finally(() => {
      preloader.classList.remove("is-loading");
    });
  }

  normalizeWeight(weightString) {
    if (weightString === "") { return 0 }
    return parseFloat(weightString.replace(",", "."))
  }

  get destinationId() {
    return this.data.get("id")
  }

  get newDeliveryUrl() {
    return this.data.get("new-delivery-url")
  }

  openModal(event) {
    const td = event.target.closest("td")

    const modal = td.querySelector(".modal")

    modal.classList.add("is-active")
  }

  closeModal(event) {
    event.preventDefault()
    const modal = document.querySelector(".modal.is-active")
    modal.classList.remove("is-active")
  }

  openTab(event) {
    event.preventDefault();

    const ul = event.target.closest("ul")
    const tabs = ul.querySelectorAll("li")
    const contents = document.querySelectorAll("[data-tab]")

    Array.from(contents).forEach(elem => {
      elem.classList.add("is-hidden")
    })

    Array.from(tabs).forEach(elem => {
      elem.classList.remove("is-active")
    })
    
    event.target.closest("li").classList.add("is-active")
    const contentToOpen = event.target.dataset.target
    
    document.querySelector(`[data-tab='${contentToOpen}']`).classList.remove("is-hidden")
  }
}